<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/b2BToB2COrder.js";
export default {
  name: "b2BToB2COrder",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "getAllClient",
            optionsKey: "",
          },
          {
            key: "to_country",
            placeholder() {
              return this.$tz("目的国");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$tz("B2B订单号"),
          key: "b2b_awb",
          minWidth: 130,
          copy: true,
          header: {
            copy: true,
          },
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_country",
          minWidth: 130,
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 130,
        },
        {
          name: () => this.$t("Tracker Status"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$t("track_title"),
          key: "status_remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("tracker_time"),
          key: "status_time",
          minWidth: 130,
          methods: {
            render({ value }) {
              return this.format.zoneDate({ value });
            },
          },
        },
        {
          name: () => this.$t("clientName"),
          key: "clientName",
          minWidth: 130,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "serviceName",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
